/**
 * Map an AI-SDK tool-part state onto the ToolCall component's state enum.
 *
 * Hoisted here because the flow-builder tool renderers, the docs panel, and
 * the assistant each need the identical mapping.
 */

import type { ToolCallState } from '@chatsdet/ui';

export function mapToolState(aiSdkState: string): ToolCallState {
  switch (aiSdkState) {
    case 'input-streaming':
      return 'streaming';
    case 'input-available':
      return 'pending';
    case 'output-available':
      return 'success';
    case 'output-error':
      return 'error';
    default:
      return 'pending';
  }
}
